// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1en5m","label":"Category_label__Savcm","content":"Category_content__2jKd7","header":"Category_header__3HcoT","location":"Category_location__XbxJo"};